export const PERMISSOES_GERENCIAR_PAGAMENTOS = {
  CRIAR: "criar_lote_pagamento_v2",
  REPROVAR: "reprovar_lote_pagamento_v2",
  APROVAR: "aprovar_lote_pagamento_v2",
  SOLICITAR_CORRECAO: "solicitar_correcao_lote_pagamento_v2",
  VALIDAR: "validar_lote_pagamento_v2",
  CONFIRMAR_PAGAMENTO: "confirmar_pagamento_lote_v2",
  EDITAR: "editar_lote_pagamento_v2",
  EXCLUIR: "excluir_lote_pagamento",
};

export function temPermissao(
  listaPermissoes: { nome_funcionalidade: string }[],
  nomeFuncionalidade: string,
): boolean {
  return (
    Array.isArray(listaPermissoes) &&
    listaPermissoes.some((item) => item.nome_funcionalidade === nomeFuncionalidade)
  );
}
